<template>
  <div class="add-disease-wrapper">
    <div class="add-disease-title">Adaugă dăunători</div>
    <div class="title-separator"></div>
    <div class="add-disease-input-label" v-if="false">Tipuri de dăunători</div>
    <div class="add-disease-types">
      <div
        :class="['add-disease-type-button', 'left-button', { 'button-selected': selectedTypeCode == 'BL' }]"
        @click="selectDiseaseType('BL')"
      >
        <img v-if="selectedTypeCode == 'BL'" src="@/assets/images/icons/ciuperca_white.svg" />
        <img v-else src="@/assets/images/icons/ciuperca.svg" />
      </div>
      <div :class="['add-disease-type-button', { 'button-selected': selectedTypeCode == 'DN' }]" @click="selectDiseaseType('DN')">
        <img v-if="selectedTypeCode == 'DN'" src="@/assets/images/icons/bug_white.svg" />
        <img v-else src="@/assets/images/icons/bug.svg" />
      </div>
      <div :class="['add-disease-type-button', { 'button-selected': selectedTypeCode == 'BR' }]" @click="selectDiseaseType('BR')">
        <img v-if="selectedTypeCode == 'BR'" src="@/assets/images/icons/fungicid_disease_white.svg" />
        <img v-else src="@/assets/images/icons/fungicid_disease.svg" />
      </div>
      <div :class="['add-disease-type-button', { 'button-selected': selectedTypeCode == 'SM' }]" @click="selectDiseaseType('SM')">
        <img v-if="selectedTypeCode == 'SM'" src="@/assets/images/icons/straturi_white.svg" />
        <img v-else src="@/assets/images/icons/straturi.svg" />
      </div>
      <div
        :class="['add-disease-type-button', 'right-button', { 'button-selected': selectedTypeCode == 'ALT' }]"
        :title="$t('scouting_custom_diseases')"
        @click="selectDiseaseType('ALT')"
      >
        <img v-if="selectedTypeCode == 'ALT'" src="@/assets/images/icons/plus.svg" />
        <img v-else src="@/assets/images/icons/plus_green.svg" />
      </div>
    </div>
    <div class="add-disease-input-label" v-if="false">Dăunători</div>
    <b-input-group class="search_disease">
      <b-input-group-prepend>
        <img src="~@/assets/images/icons/search.svg" />
      </b-input-group-prepend>
      <b-form-input placeholder="Caută dăunători" v-model="disease_search_text" :disabled="creatingDisease"></b-form-input>
      <button
        type="button"
        class="input-plus-button"
        v-if="showAddDiseaseButton"
        :disabled="creatingDisease"
        :title="$t('scouting_custom_disease_add')"
        :aria-label="$t('scouting_custom_disease_add')"
        @click="addNewDisease"
      >
        <img src="@/assets/images/icons/plus_green.svg" />
      </button>
    </b-input-group>
    <DxScrollView ref="add-disease-list" class="add-disease-list" :use-native="true" @reach-bottom="reachBottom">
      <div>
        <div>
          <b-form-checkbox
            v-if="d.name.length > 0 && d.name != '-'"
            class="disease-checkbox-row"
            v-for="d in (disease_list ? disease_list : []).filter((obj) => {
              return obj.name.toUpperCase().includes(disease_search_text.toUpperCase());
            })"
            :key="d.uuid"
            v-model="selected_diseases"
            :value="d.uuid"
            @change="diseaseSelectChanged"
          >
            {{ d.name }}
          </b-form-checkbox>
        </div>
      </div>
    </DxScrollView>
    <div class="add-disease-input-label" v-show="false">Gradul de infectare</div>
    <div class="add-disease-infection-level">
      <div
        :class="['add-disease-infection-level-item', 'left-button', { 'button-selected': infectionLevel == 1 }]"
        @click="selectInfectionLevel(1)"
      >
        Scăzut
      </div>
      <div :class="['add-disease-infection-level-item', { 'button-selected': infectionLevel == 2 }]" @click="selectInfectionLevel(2)">
        Mediu
      </div>
      <div
        :class="['add-disease-infection-level-item', 'right-button', { 'button-selected': infectionLevel == 3 }]"
        @click="selectInfectionLevel(3)"
      >
        Înalt
      </div>
    </div>
    <toast-message ref="toastMessage"></toast-message>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DxScrollView } from "devextreme-vue/scroll-view";
import ToastMessage from "../../../components/Mobile/toastMessage.vue";

export default {
  name: "AddDisease",
  data() {
    return {
      selectedTypeCode: "",
      infectionLevel: 0,
      disease_list: [],
      disease_pagination: {},
      selected_diseases: [],
      selected_diseases_objects: [],
      disease_search_text: "",
      allow_filter_by_text: true,
      searchTimer: {},
      loadingDiseases: false,
      creatingDisease: false,
      loadSequence: 0,
      formSequence: 0,
    };
  },
  components: {
    DxScrollView,
    ToastMessage,
  },
  computed: {
    showAddDiseaseButton() {
      return (
        this.selectedTypeCode == "ALT" &&
        !this.loadingDiseases &&
        this.disease_search_text.trim().length > 0 &&
        !(this.disease_list || []).some((obj) => {
          return obj.name.toUpperCase() === this.disease_search_text.trim().toUpperCase();
        })
      );
    },
  },
  watch: {
    disease_search_text: function () {
      if (this.allow_filter_by_text) {
        clearTimeout(this.searchTimer);

        this.searchTimer = setTimeout(() => {
          this.selectDiseaseType(this.selectedTypeCode, false);
        }, 500);
      }
    },
  },
  methods: {
    ...mapActions({
      getDiseases: "scouting/getDiseases",
      getMyFitoDiseases: "scouting/getMyFitoDiseases",
      createMyFitoDisease: "scouting/createMyFitoDisease",
    }),
    async addNewDisease() {
      const name = this.disease_search_text.trim();
      if (this.selectedTypeCode !== "ALT" || !name || this.creatingDisease) {
        return;
      }
      const formSequence = this.formSequence;
      this.creatingDisease = true;
      try {
        const response = await this.createMyFitoDisease({ name });
        const newDisease = response.data;
        if (formSequence !== this.formSequence || this.selectedTypeCode !== "ALT") {
          return;
        }
        clearTimeout(this.searchTimer);
        this.allow_filter_by_text = false;
        this.disease_search_text = "";
        await this.$nextTick();
        this.allow_filter_by_text = true;
        await this.selectDiseaseType("ALT");
        if (formSequence !== this.formSequence || this.selectedTypeCode !== "ALT") {
          return;
        }
        if (!this.disease_list.some((disease) => disease.uuid === newDisease.uuid)) {
          this.disease_list.unshift(newDisease);
        }
        if (!this.selected_diseases.includes(newDisease.uuid)) {
          this.selected_diseases.push(newDisease.uuid);
        }
        this.diseaseSelectChanged(this.selected_diseases);
      } catch (error) {
        this.$refs.toastMessage.showError(this.$t("error_alert_text"));
      } finally {
        this.creatingDisease = false;
      }
    },
    resetForm() {
      clearTimeout(this.searchTimer);
      this.loadSequence++;
      this.formSequence++;
      this.loadingDiseases = false;
      const diseaseList = this.$refs["add-disease-list"];
      if (diseaseList?.instance) {
        diseaseList.instance.release(true);
      }
      this.selectedTypeCode = "";
      this.disease_list = [];
      this.disease_pagination = {};
      this.selected_diseases = [];
      this.selected_diseases_objects = [];
      this.disease_search_text = "";
      this.infectionLevel = 0;
    },
    async selectDiseaseType(typeCode, nextPage = false) {
      if (!typeCode || (nextPage && this.loadingDiseases)) {
        return;
      }
      clearTimeout(this.searchTimer);
      let pageNumber = 1;
      if (nextPage) {
        pageNumber = this.disease_pagination.next_page;
      }
      if (this.selectedTypeCode != typeCode) {
        this.formSequence++;
        this.selected_diseases = [];
        this.selected_diseases_objects = [];
        this.disease_list = [];
        this.disease_pagination = {};
        this.allow_filter_by_text = false;
        this.disease_search_text = "";
        this.allow_filter_by_text = true;
      }
      this.selectedTypeCode = typeCode;
      const sequence = ++this.loadSequence;
      this.loadingDiseases = true;
      const getDiseases = typeCode === "ALT" ? this.getMyFitoDiseases : this.getDiseases;
      try {
        const response = await getDiseases({
          code: typeCode,
          name: this.disease_search_text.trim(),
          page: pageNumber,
        });
        if (sequence !== this.loadSequence) {
          return;
        }
        if (nextPage) {
          response.data.forEach((element) => {
            let checkDisease = this.disease_list.find((obj) => obj.uuid == element.uuid);
            if (checkDisease == undefined) {
              this.disease_list.push(element);
            }
          });
        } else {
          this.disease_list = response.data;
        }
        this.disease_pagination = response.pagination;
        this.fillCallback();
      } catch (error) {
        if (sequence === this.loadSequence) {
          this.$refs.toastMessage.showError(this.$t("error_alert_text"));
          const diseaseList = this.$refs["add-disease-list"];
          diseaseList?.instance?.release(true);
        }
      } finally {
        if (sequence === this.loadSequence) {
          this.loadingDiseases = false;
        }
      }
    },
    selectInfectionLevel(lvl) {
      this.infectionLevel = lvl;
    },
    checkIfDataIsValid() {
      if (this.creatingDisease) {
        return false;
      }
      if (this.selectedTypeCode == "") {
        this.$refs.toastMessage.showError("Selectați tipul de dăunători!");
      } else if (this.selected_diseases.length == 0) {
        this.$refs.toastMessage.showError("Selectați măcar un dăunători!");
      } else if (this.infectionLevel == 0) {
        this.$refs.toastMessage.showError("Selectați gradul de infectarei!");
      } else {
        return true;
      }
      return false;
    },
    reachBottom() {
      if (this.disease_pagination.current_page < this.disease_pagination.last_page) {
        this.selectDiseaseType(this.selectedTypeCode, true);
      }
    },
    fillCallback() {
      const diseaseList = this.$refs["add-disease-list"];
      if (!diseaseList?.instance) {
        return;
      }
      if (this.disease_pagination.current_page == this.disease_pagination.last_page || this.disease_list.length == 0) {
        diseaseList.instance.release(true);
      } else {
        diseaseList.instance.release(false);
      }
      diseaseList.instance.update();
      if (this.disease_pagination.current_page == 1) {
        diseaseList.instance.scrollTo(0);
      }
    },
    getDataAtApply() {
      return {
        diseases: this.selected_diseases_objects,
        infection_level: this.infectionLevel,
      };
    },
    diseaseSelectChanged(options) {
      options.forEach((option_element) => {
        let checkObj = this.selected_diseases_objects.find((obj) => obj.uuid == option_element);
        if (checkObj == undefined) {
          checkObj = this.disease_list.find((obj) => obj.uuid == option_element);
          if (checkObj != undefined) {
            this.selected_diseases_objects.push(checkObj);
          }
        }
      });
      this.selected_diseases_objects = this.selected_diseases_objects.filter((obj) => {
        return options.find((obj_option) => obj_option == obj.uuid) != undefined;
      });
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
    this.loadSequence++;
    this.formSequence++;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/scoutingMobile/addDisease.scss";
</style>
